import './Main.css'
import { Link ,useNavigate,Outlet } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'
import Header from '../../CmsComponents/Header/Header'
import SideBar from '../../CmsComponents/SideBar/SideBar'


const Main = () => {
  return (
    <div className='mainPageDash'>
<div className='HomeDash'>
      <div className='Home_leftDash'>
      <SideBar/>
      </div>

      <div className='Home_rightDash'>
        <div className='Home_right_topDash'>
          <Header/>
        </div>
        <div className='Home_right_bottomDash'>
          <Outlet/>
        </div>
      </div>
    </div>
    </div>
  )
}

export default Main
